export default "__VITE_ASSET__6ec76d58__"